export enum ViewType {
  LIST = 'list',
  GRID = 'grid',
}
